import {
  CREATE_ELITE_REPORTING_OFFER,
  UPDATE_ELITE_REPORTING_OFFER,
  UNLOAD_ELITE_REPORTING_OFFER,
  ELITE_REPORTING_OFFER_FETCHED_SUCCESS,
  RESET_ELITE_REPORTING_OFFER,
} from '../constants/actionTypes';

const initialState = {
  offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_ELITE_REPORTING_OFFER:
    case UPDATE_ELITE_REPORTING_OFFER:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_ELITE_REPORTING_OFFER:
      return {
        ...state,
        message: '',
      };

    case ELITE_REPORTING_OFFER_FETCHED_SUCCESS:
      return {
        ...state,
        offers: action.payload.offers,
        pager: action.payload.pager,
      };

    case UNLOAD_ELITE_REPORTING_OFFER:
      return initialState;

    default:
      return state;
  }
};
